import { useState } from "react";
import { useAdmin } from "@/contexts/AdminContext";
import { Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { admin, login, loading } = useAdmin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-slate-50"><p className="text-slate-400">Loading...</p></div>;
  if (admin) return <Navigate to="/admin/dashboard" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Logged in successfully");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A1628] px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-1.5 mb-4">
            <div className="flex flex-col gap-[3px]">
              <div className="w-5 h-[2px] bg-[#C5A059]"></div>
              <div className="w-5 h-[2px] bg-[#C5A059]"></div>
            </div>
            <span className="font-heading text-white text-xl font-medium">Equaliser</span>
            <span className="text-white/50 text-xl font-light">Legal</span>
          </div>
          <p className="text-white/40 text-sm uppercase tracking-wider">Admin Panel</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white p-8 rounded-[2px] shadow-xl" data-testid="admin-login-form">
          <div className="flex items-center gap-2 mb-6">
            <Lock size={18} className="text-[#C5A059]" />
            <h2 className="font-heading text-xl text-[#0A1628] font-medium">Sign In</h2>
          </div>
          <div className="space-y-5">
            <div>
              <label className="text-xs uppercase tracking-wider text-slate-400 block mb-2">Email</label>
              <input type="email" data-testid="admin-email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@equaliserlegal.com" className="w-full border border-slate-200 px-4 py-3 text-sm focus:border-[#0A1628] focus:outline-none rounded-[2px]" required />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-slate-400 block mb-2">Password</label>
              <input type="password" data-testid="admin-password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter password" className="w-full border border-slate-200 px-4 py-3 text-sm focus:border-[#0A1628] focus:outline-none rounded-[2px]" required />
            </div>
            <button type="submit" data-testid="admin-login-submit" disabled={submitting} className="w-full bg-[#0A1628] text-white py-3 text-sm uppercase tracking-wider font-medium hover:bg-[#1a2c4e] transition-colors rounded-[2px] disabled:opacity-50">
              {submitting ? "Signing in..." : "Sign In"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
